app.controller('patientStateOfHealthController', ['$scope', '$state', 'config', '$translate', 'objectHelper', 'baseModel', 'applicationModel', 'visitModel', 'userModel', 'patientModel', 'allergyModel', 'vaccinationAndSerumModel', 'takenDrugModel', 'geneticDisorderModel',
    function ($scope, $state, config, $translate, objectHelper, baseModel, applicationModel, visitModel, userModel, patientModel, allergyModel, vaccinationAndSerumModel, takenDrugModel, geneticDisorderModel) {

        function setData() {
            $scope.setStretchView();
            $scope.firstVisitDataFill = false;

            $scope.selectedCategory = {
                ALL: true,
                ALLERGIES: false,
                TAKEN_DRUGS: false,
                DIAGNOSES: false,
                HOSPITAL_AND_SANATORIUMS: false,
                LABORATORY_TEST_RESULTS: false,
                VACCINATION_AND_SERUMS: false,
                GENETIC_DISORDERS: false
            }
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on('$destroy', function () {
            });

            if(!config.MEEDY) {
                $scope.$watch('$parent.visit', function(newVal) {
                    if(newVal) {
                        $scope.firstVisitDataFill = (newVal.firstForPatientDoctor && newVal.visitStatus === Enum.VISIT_STATUS.PLANNED) ? true : false;
                    }
                })
            } else {
                $scope.$on(Event.VISIT.GET_BY_ID.SUCCESS, function(event, visit) {
                    $scope.firstVisitDataFill = (visit.firstForPatientDoctor && visit.visitStatus === Enum.VISIT_STATUS.PLANNED) ? true : false;
                })
            }

            
        }

        function setActions() {

            $scope.beginFirstVisit = function() {
                $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD, { patientId: $scope.visit.patient.id, visitId: $scope.visit.id });
            };

            $scope.selectCategory = function(category) {
                Object.keys($scope.selectedCategory).forEach(function(prop) {
                    $scope.selectedCategory[prop] = false;
                });
                $scope.selectedCategory[category] = true;
            };

        }

        function configureInterface() {
        }

        function initialize() {
            if(config.MEEDY && $state.params.visitId) {
                visitModel.getById($state.params.visitId);
            }
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        initialize();
        configureInterface();
    }
]);